module.exports = __webpack_public_path__ + "img/momo_button_point_record_active.d7d42cc0.png";